export default "__VITE_ASSET__CjJJB84q__"